import { type ReactNode } from 'react';

export function Helmet({ children }: { children: ReactNode }) {
  return <>{children}</>;
}